import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (latin subset only; weights the site actually uses).
// Replaces the render-blocking Google Fonts stylesheet in public/index.html —
// the same woff2 files now ship hashed from our own origin.
import '@fontsource/anton/latin-400.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Track every phone-number tap sitewide with one delegated listener, since
// tel: links appear in a dozen components. Fires a GA4 event plus the Google
// Ads "Click to call" conversion (Phone call lead, created 2026-08-11).
const PHONE_CONVERSION_LABEL = 'JyW1CNfFi-AcEL7XlrhE';
document.addEventListener('click', event => {
  const link = event.target.closest && event.target.closest('a[href^="tel:"]');
  if (!link || !window.gtag) return;
  window.gtag('event', 'phone_click', {
    link_url: link.getAttribute('href'),
    page_path: window.location.pathname
  });
  if (PHONE_CONVERSION_LABEL) {
    window.gtag('event', 'conversion', {
      send_to: `AW-18371423166/${PHONE_CONVERSION_LABEL}`,
      value: 1.0,
      currency: 'USD'
    });
  }
});

const container = document.getElementById('root');

// scripts/prerender.mjs writes real markup into #root at build time, so when
// it's there we hydrate it rather than discarding it and re-rendering.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
